const ServiceMesureImportStyle = {};

const ServiceMesureImportResultStyle = {
  border: "1px solid",
  borderRadius: "3px",
};

const importErrorsWrapperStyle = {
  bg: "cardSecondary",
  borderRadius: "5px 0 0 5px",
  m: "2",
  maxHeight: "500px",
  overflow: "auto",
  p: "5",
};

export {
  ServiceMesureImportStyle,
  ServiceMesureImportResultStyle,
  importErrorsWrapperStyle,
};
